// extracted by mini-css-extract-plugin
export default {"root":"universal-loader_root__JN6t8"};